<i18n locale="en">
{
  "labels": {
    "order": "Order Now"
  },
  "unavailable": {
    "catering": "Catering page is not live. Choose another destination to send.",
    "catering-menu": "Catering menu is not live. Choose another destination to send.",
    "unknown": "Catering destination availability could not be verified. Reload the campaign to try again."
  }
}
</i18n>

<template>
  <PreviewSheet background="primary" radius="0" class="px-4 py-3">
    <OwnType
      v-if="unavailableMessage"
      color="danger"
      role="alert"
      :text="unavailableMessage"
    />
    <PreviewButton
      v-else
      color="primary"
      size="small"
      :title="buttonLabel"
      width="full-width"
    />
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'

import PreviewButton from '@/lib/builder/public/preview/PreviewButton.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import globalStore from '@/store'
import { OwnType } from '@/ui/OwnType'

import { getBrandCateringDestinations } from '../../../composables/useBrandCateringDestinations'

const { t } = useI18n()
const props = defineProps({ content: { type: Object, required: true } })
const storeModule = inject('storeModule')
const buttonLabel = computed(
  () => props.content.data?.label ?? t('labels.order')
)
const resource = computed(
  () => storeModule && globalStore.getters[`${storeModule}/currentResource`]
)
const unavailableMessage = computed(() => {
  const destinations = getBrandCateringDestinations(resource.value?.brandId)
  if (
    destinations === null &&
    (props.content.data?.link === 'catering' ||
      props.content.data?.link === 'catering-menu')
  ) {
    return t('unavailable.unknown')
  }
  if (
    destinations &&
    props.content.data?.link === 'catering' &&
    !destinations.cateringUrl
  ) {
    return t('unavailable.catering')
  }
  if (
    destinations &&
    props.content.data?.link === 'catering-menu' &&
    !destinations.cateringMenuUrl
  ) {
    return t('unavailable.catering-menu')
  }
  return null
})
</script>
